const getters = {
    getFamilyPath: state => state.path
}

export default getters